<template>
  <div
    v-if="visible"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto"
    @click.self="$emit('close')"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 max-w-4xl w-full mx-4 my-8"
    >
      <div class="p-6">
        <div class="mb-6 flex items-start justify-between gap-4">
          <div>
            <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Choose event type</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Select the format that best matches how this event will run.
            </p>
          </div>
          <Button label="Cancel" severity="secondary" class="shrink-0" @click="$emit('close')" />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <button
            v-for="option in EVENT_TYPE_OPTIONS"
            :key="option.value"
            type="button"
            class="text-left rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden transition-all focus:outline-none focus:ring-2 focus:ring-teal-500"
            :class="
              option.selectable
                ? 'hover:border-teal-500 dark:hover:border-teal-400 hover:shadow-md cursor-pointer'
                : 'opacity-50 cursor-not-allowed'
            "
            :disabled="!option.selectable"
            @click="handleSelect(option)"
          >
            <div class="relative aspect-[3/4] w-full">
              <img
                :src="getEventTypeImage(option.value, themeStore.isDark)"
                :alt="option.label"
                class="absolute inset-0 h-full w-full object-cover rounded-b-xl"
              />
              <div
                class="absolute inset-x-0 top-0 p-4"
                :class="
                  themeStore.isDark
                    ? 'bg-gradient-to-b from-black/70 via-black/40 to-transparent text-white'
                    : 'text-gray-900'
                "
              >
                <div class="flex items-start justify-between gap-2">
                  <h3 class="text-lg font-bold">{{ option.label }}</h3>
                  <span
                    v-if="!option.selectable"
                    class="shrink-0 rounded-full px-2 py-0.5 text-xs font-medium"
                    :class="
                      themeStore.isDark ? 'bg-white/20 text-white' : 'bg-gray-200 text-gray-700'
                    "
                  >
                    Coming soon
                  </span>
                </div>
                <p
                  class="mt-2 text-sm leading-snug"
                  :class="themeStore.isDark ? 'text-white/90' : 'text-gray-600'"
                >
                  {{ option.description }}
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "primevue/button";
import { useThemeStore } from "@/stores/theme";
import { EVENT_TYPE_OPTIONS, getEventTypeImage } from "@/constants/eventTypes";

export default {
  name: "EventTypePickerModal",
  components: {
    Button
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ["select", "close"],
  setup(props, { emit }) {
    const themeStore = useThemeStore();

    const handleSelect = (option) => {
      if (!option.selectable) return;
      emit("select", option.value);
    };

    return {
      EVENT_TYPE_OPTIONS,
      themeStore,
      getEventTypeImage,
      handleSelect
    };
  }
};
</script>
